import { fromWei, toWei } from ".."
import Contract from "./Contract"

export default class MatryxToken extends Contract {
  async balanceOf(address) {
    const balance = await this.contract.balanceOf(address)
    return fromWei(balance)
  }

  async allowance(owner, spender) {
    const allowance = await this.contract.allowance(owner, spender)
    return fromWei(allowance)
  }

  // STATE MUTATING METHODS

  async approve(spender, amount) {
    amount = toWei(amount)
    return await this.contract.approve(spender, amount)
  }

  async transfer(recipient, amount) {
    amount = toWei(amount)
    return await this.contract.transfer(recipient, amount)
  }
}
